import { remarksSchema } from './common';
import { logindId } from './regex';
import { companyIdSchema } from './shop';
import { shopIdSchema } from './terminal';

import {
  InferType,
  object,
  string,
} from '@/validations/custom-yup';

/** 氏名 */
export const accountNameSchema = string()
  .label('氏名')
  .required()
  .max(100);

/** ログインID */
export const loginIdSchema = string()
  .label('ログインID')
  .required()
  .matches(logindId, 'ログインIDのフォーマットを確認してください。')
  .min(8, 'ログインIDは8~70文字で入力してください。')
  .max(70, 'ログインIDは8~70文字で入力してください。');

/** メールアドレス(必須)
*/
export const emailAddressSchema = string()
  .label('メールアドレス')
  .required()
  .email('メールアドレスのフォーマットを確認してください。')
  .min(6, 'メールアドレスは6~100文字で入力してください。')
  .max(100, 'メールアドレスは6~100文字で入力してください。');

/** 権限 */
export const roleSchema = string<'ACQUIRER_MANAGER' | 'ACQUIRER_STAFF' | 'COMPANY_MANAGER' | 'COMPANY_STAFF' | 'SHOP_MANAGER' | 'SHOP_STAFF' | 'SYSTEM_MANAGER' | 'SYSTEM_STAFF' | 'TENANT_MANAGER' | 'TENANT_STAFF' | 'VALUE_ISSUER_MANAGER' | 'VALUE_ISSUER_STAFF' | 'WALLET_SERVICE_MANAGER' | 'WALLET_SERVICE_STAFF'>()
  .label('権限')
  .required();
export const acquirerIdSchema = string()
  .label('アクワイアラ');
export const issuerIdSchema = string()
  .label('イシュア');
export const accountWalletServiceIdSchema = string()
  .label('ウォレットサービス');

export const accountEditFormSchema = object({
  name: accountNameSchema,
  loginId: loginIdSchema,
  email: emailAddressSchema,
  remarks: remarksSchema(),
});

export const accountRegisterFormSchema = object({
  role: roleSchema,
  name: accountNameSchema,
  loginId: loginIdSchema,
  email: emailAddressSchema,
  acquirerId: acquirerIdSchema,
  issuerId: issuerIdSchema,
  walletServiceId: accountWalletServiceIdSchema,
  companyId: companyIdSchema,
  shopId: shopIdSchema,
  remarks: remarksSchema(),
});

export type AccountEditForm = InferType<typeof accountEditFormSchema>;
export type AccountRegisterForm = InferType<typeof accountRegisterFormSchema>;
